/**
 * Analytics function to help get current time from fetch start.
 */

let navigationStart: number | null = null;
let bookingsModuleStart: number | null = null;

export enum LoadType {
    FirstTime = 'First Time',
    InternalNavigation = 'Internal Navigation',
}

export const getLoadType = () =>
    navigationStart === null ? LoadType.FirstTime : LoadType.InternalNavigation;

export const setNavigationStart = (time: number) => {
    navigationStart = time;
};

export const setBookingsModuleStart = (time: number) => {
    bookingsModuleStart = time;
};

export const getBookingsModuleStartTime = (): number | undefined => {
    return Math.round(bookingsModuleStart as number);
};

const getTimeFromFetchStart = (timeMeasured?: number) => {
    const currentTime = timeMeasured ?? window.performance.now();

    let offset: number;
    if (navigationStart) {
        offset = navigationStart;
    } else {
        const timing = window.performance.getEntriesByType(
            'navigation'
        )[0] as PerformanceNavigationTiming;
        offset = timing.fetchStart as number;
    }

    return Math.round(currentTime - offset);
};

export default getTimeFromFetchStart;
